import { WidgetType } from "@codemirror/view";
import {
    attachSyntaxEditInteractions,
    createPrettySyntaxShell,
    createSyntaxBadge,
    createTextSpan,
} from "../shared/widgets";

type FenceKind = "config" | "output" | "inputs";
type FenceRole = "open" | "close";

function getFenceBadge(kind: FenceKind): string {
    if (kind === "config") return "C";
    if (kind === "output") return "O";
    return "I";
}

export class PrettyFenceWidget extends WidgetType {
    constructor(
        readonly kind: FenceKind,
        readonly role: FenceRole,
        readonly length: number,
    ) {
        super();
    }

    eq(other: PrettyFenceWidget): boolean {
        return (
            other.kind === this.kind &&
            other.role === this.role &&
            other.length === this.length
        );
    }

    toDOM(): HTMLElement {
        const icon = createSyntaxBadge(getFenceBadge(this.kind));
        icon.classList.add(
            "cm-magic-fence-pretty-icon",
            `cm-magic-fence-pretty-icon-${this.kind}`,
        );

        const wrapper = createPrettySyntaxShell({
            wrapperClass: [
                "cm-magic-fence-pretty",
                `cm-magic-fence-pretty-${this.kind}`,
                `cm-magic-fence-pretty-${this.role}`,
            ].join(" "),
            badge: icon,
            primary: [
                createTextSpan(
                    "cm-magic-fence-pretty-kind",
                    this.role === "open" ? this.kind : `end ${this.kind}`,
                ),
            ],
            detail: null,
        });
        wrapper.title =
            this.role === "open"
                ? `${"`".repeat(this.length)}${this.kind}`
                : "`".repeat(this.length);
        attachSyntaxEditInteractions(wrapper);
        return wrapper;
    }

    ignoreEvent(): boolean {
        return true;
    }
}
